import { TopUpPointsFeatures } from 'features';
import React from 'react';

const TopUpPointsPage = () => {
  return <TopUpPointsFeatures />;
};

export default TopUpPointsPage;
